import {
  createEntityAdapter,
  createSlice,
  PayloadAction,
  nanoid,
} from '@reduxjs/toolkit';
import type { RootState } from '~/store';

const notificationsAdapter = createEntityAdapter<{
  id: string;
  message: string;
  duration: number;
}>();

// Radix UI Toast has no way to leave the notification permanent
// so we make the duration last one day
const DAY_DURATION = 1440000;
const DEFAULT_DURATION = 3000;

export const notificationsSlice = createSlice({
  name: 'notifications-new',
  initialState: notificationsAdapter.getInitialState(),
  reducers: {
    addNotification: (state, action: PayloadAction<string>) => {
      const notification = {
        id: nanoid(),
        message: action.payload,
        duration: DEFAULT_DURATION,
      };
      notificationsAdapter.addOne(state, notification);
    },
    addPermanentNotification: (state, action: PayloadAction<string>) => {
      const notification = {
        id: nanoid(),
        message: action.payload,
        duration: DAY_DURATION,
      };
      notificationsAdapter.addOne(state, notification);
    },
    removeNotification: notificationsAdapter.removeOne,
  },
});

export const { addNotification, removeNotification, addPermanentNotification } =
  notificationsSlice.actions;

export const { selectAll: selectAllNotifications } =
  notificationsAdapter.getSelectors(
    (state: RootState) => state[notificationsSlice.name]
  );
